module.exports = __webpack_public_path__ + "media/images/icon_edit-e4b5ae1c168847a547c52e3433b76e70.png";